export const FETCH_MODAL_LINKS_SUCCESS = 'FETCH_MODAL_LINKS_SUCCESS'
export const GET_RELATED_MODAL_LINKS_SUCCESS = 'GET_RELATED_MODAL_LINKS_SUCCESS'
export const GET_MODAL_LINK_SUCCESS = 'GET_MODAL_LINK_SUCCESS'
export const ADD_MODAL_LINK_SUCCESS = 'ADD_MODAL_LINK_SUCCESS'
export const UPDATE_MODAL_LINK_SUCCESS = 'UPDATE_MODAL_LINK_SUCCESS'
export const DELETE_MODAL_LINK_SUCCESS = 'DELETE_MODAL_LINK_SUCCESS'

export const API_REQUEST_START = 'API_REQUEST_START'
export const API_REQUEST_FAIL = 'API_REQUEST_FAIL'
